import { render, staticRenderFns } from "./tabCalendar.vue?vue&type=template&id=22a3592c&scoped=true&"
import script from "./tabCalendar.vue?vue&type=script&lang=js&"
export * from "./tabCalendar.vue?vue&type=script&lang=js&"
import style0 from "./tabCalendar.vue?vue&type=style&index=0&id=22a3592c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a3592c",
  null
  
)

export default component.exports